import { omit } from "lodash";
import BesselChart from "./BesselChart";
import classNames from "classnames";

export const useCptUtil = ({ data }: any) => {
  const getCpt01 = () => {
    if (isEmptyType(data?.SunMoon?.Sun || data?.SunMoon?.Moon)) {
      return null;
    }
    return (
      <BesselChart
        SunMoon={{
          ...data?.SunMoon,
          ...omit(data, ["SunMoon"]),
        }}
      />
    );
  };

  const getCpt02 = ({ useAdCpt, pathname, MoonPhaseSection, SunMoonSection, getMainDomain }: any) => {
    return (
      <div className={classNames(["flex flex-col justify-start gap-y-10 box-border p-[0_16px]"])}>
        <div data-position="position-26">{useAdCpt("position-26", pathname)}</div>
        <div data-position="position-10">{useAdCpt("position-10", pathname)}</div>
        {getMainDomain() === "24hweather.com" ? (
          <>
            <MoonPhaseSection />
            <SunMoonSection />
          </>
        ) : (
          <>
            <SunMoonSection />
            <div data-position="position-25">{useAdCpt("position-25", pathname)}</div>
            <MoonPhaseSection />
          </>
        )}
      </div>
    );
  };

  return { getCpt01, getCpt02 };
};
